export const codeValidator = (val: string) => (val.length < 4 ? true : RegExp("^\\d{4}$").test(val))
